export enum ImportJobSummaryStatus {
	Pending = 'pending',
	InProgress = 'inProgress',
	Completed = 'completed',
	Failed = 'failed'
}
